export const TOUR_STEPS = [
  {
    target: '[data-tour="searchbar"]',
    title: 'Describí lo que buscás o en qué lugar',
    content: 'Escribí una ciudad, barrio o dirección. O contanos qué tipo de lote buscás y lo interpretamos por vos.',
    placement: 'bottom',
    skipBeacon: true,
  },
  {
    target: '[data-tour="filtros"]',
    title: 'Filtros de lotes',
    content: 'Acotá los lotes de la vista por tipo, superficie, entorno y más.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="espacios"]',
    title: 'Tu espacio',
    content: 'Cambiá entre tu espacio y los que te compartieron. Desde acá también invitás a tu equipo.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="toggle-parcelas"]',
    title: 'Lotes catastrales',
    content: 'Activá o desactivá la capa de lotes sobre el mapa.',
    placement: 'left',
  },
  {
    target: '[data-tour="map-style"]',
    title: 'Estilo de mapa',
    content: 'Satelital o calles según lo que necesitás.',
    placement: 'left',
  },
  {
    target: '[data-tour="capas"]',
    title: 'Capas de referencia',
    content: 'Zonificación, inundación, pobreza crónica y más.',
    placement: 'left',
  },
  {
    target: '[data-tour="puntos-interes"]',
    title: 'Puntos de interés',
    content: 'Escuelas, centros de salud, parques y más.',
    placement: 'left',
  },
  {
    target: '[data-tour="mis-lotes"]',
    title: 'Registros',
    content: 'Guardá lotes, filtrá por marcadores y organizá tus registros.',
    placement: 'right',
  },
  {
    target: '[data-tour="mis-listas"]',
    title: 'Listas',
    content: 'Organizá y compartí lotes con colegas o clientes.',
    placement: 'right',
  },
  {
    target: '[data-tour="leads"]',
    title: 'Leads',
    content: 'Seguí a quienes consultaron por tus listas o lotes, etapa por etapa.',
    placement: 'right',
  },
  {
    target: '[data-tour="historial"]',
    title: 'Historial',
    content: 'Revisá los últimos 20 lotes visitados.',
    placement: 'right',
  },
  {
    target: '[data-tour="meta-ads"]',
    title: 'Campañas',
    content: 'Seguí tus campañas de Meta y vinculá cada anuncio con el lote que promociona.',
    placement: 'right',
  },
  {
    target: '[data-tour="nav-controles"]',
    title: 'Controles del mapa',
    content: 'Controladores para zoom, tu ubicación y brújula.',
    placement: 'left',
  },
];

const SIDEBAR_STEP_TARGETS = new Set([
  '[data-tour="mis-lotes"]',
  '[data-tour="mis-listas"]',
  '[data-tour="leads"]',
  '[data-tour="historial"]',
  '[data-tour="meta-ads"]',
]);

const MAP_CHROME_STEP_TARGETS = new Set([
  '[data-tour="espacios"]',
  '[data-tour="filtros"]',
  '[data-tour="toggle-parcelas"]',
  '[data-tour="map-style"]',
  '[data-tour="capas"]',
  '[data-tour="puntos-interes"]',
  '[data-tour="nav-controles"]',
]);

const MOBILE_DRAWER_OPEN_MS = 320;
const MOBILE_DRAWER_CLOSE_MS = 280;

const wait = (ms) => new Promise((resolve) => {
  window.setTimeout(resolve, ms);
});

/**
 * Arma los steps del tour.
 * - hiddenTargets: targets ocultos por estado (p. ej. historial en espacio ajeno).
 * - En mobile abre/cierra el drawer antes de steps del menú lateral.
 */
export function buildTourSteps({
  isMobile,
  openNavDrawer,
  closeNavDrawer,
  hiddenTargets = [],
} = {}) {
  const hidden = new Set(hiddenTargets);
  const steps = hidden.size
    ? TOUR_STEPS.filter((step) => !hidden.has(step.target))
    : TOUR_STEPS;
  if (!isMobile) return steps;

  const openDrawer = async () => {
    openNavDrawer?.();
    await wait(MOBILE_DRAWER_OPEN_MS);
  };

  const closeDrawer = async () => {
    closeNavDrawer?.();
    await wait(MOBILE_DRAWER_CLOSE_MS);
  };

  return steps.map((step) => {
    if (SIDEBAR_STEP_TARGETS.has(step.target)) {
      return { ...step, before: openDrawer };
    }
    if (MAP_CHROME_STEP_TARGETS.has(step.target)) {
      return { ...step, before: closeDrawer };
    }
    return step;
  });
}

/**
 * Descarta steps cuyo target no está en el DOM.
 * En mobile los targets del menú lateral viven en el drawer (montado solo al abrirse,
 * vía `before`), así que no se chequean acá: su visibilidad va por hiddenTargets.
 */
export function filterStepsByDom(steps, { isMobile = false, root = document } = {}) {
  if (!root?.querySelector) return steps;
  return steps.filter((step) => {
    if (isMobile && SIDEBAR_STEP_TARGETS.has(step.target)) return true;
    return Boolean(root.querySelector(step.target));
  });
}
